import React from 'react';

import type { Text } from '@zillow/constellation';
import { AdornedInput, Adornment, FormField, Heading, Label, Paragraph } from '@zillow/constellation';
import { CurrencyInput } from '@zillow/zrs-comet';

import type { Section } from '../../../models';
import type { HTMLElementEvent } from '../../../models/Types';
import { SECURITY_DEPOSIT } from '../../../constants';
import { CURRENCY_INPUT_PLACEHOLDER } from '../../../constants/stringConstants';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

function RentalProtectionSecurityDeposit({ section, setSectionValues }: Props) {
  function onSecurityDepositChange(event: HTMLElementEvent<typeof Text>) {
    const { value } = event.currentTarget;

    setSectionValues({
      [SECURITY_DEPOSIT.FIELD_NAME.AMOUNT]: value,
    });
  }

  return (
    <>
      <Heading level={5} marginBottom="sm">
        Is this the security deposit amount in the lease you uploaded?
      </Heading>
      <Paragraph marginBottom="sm">
        <strong>Confirm that the amount shown matches the amount in your lease</strong>
      </Paragraph>
      <Paragraph marginBottom="sm">
        If you want the security deposit amount to be different than the one in the lease, we recommend uploading a new
        lease with the correction.
      </Paragraph>
      <FormField
        label={<Label>Security deposit</Label>}
        control={
          <AdornedInput
            leftAdornment={<Adornment>$</Adornment>}
            input={
              <CurrencyInput
                placeholder={CURRENCY_INPUT_PLACEHOLDER}
                value={section.getFieldValue(SECURITY_DEPOSIT.FIELD_NAME.AMOUNT)}
                onChange={onSecurityDepositChange}
                onBlur={onSecurityDepositChange}
              />
            }
          />
        }
      />
    </>
  );
}

export default RentalProtectionSecurityDeposit;
